import React from "react";

const RadioMulti = ({
  handleChange,
  inputFocus,
  label,
  inputClassName,
  name,
  value_1,
  checked_1,
  value_2,
  checked_2,
  value_3,
  checked_3,
  datagroup,
}) => {
  return (
    <>
      <label htmlFor={name} className="fw-bold mb-2">
        {label}&nbsp;<span className="text-danger">*</span>
      </label>
      <div className="form-check">
        <input
          className={"form-check-input radio-group getLabel " + inputClassName}
          type="radio"
          name={name}
          id={name}
          value={value_1}
          onChange={handleChange}
          onInput={inputFocus}
          checked={checked_1}
          datagroup={datagroup}
        />
        <label className="form-check-label">{value_1}</label>
      </div>
      <div className="form-check">
        <input
          className={"form-check-input radio-group getLabel " + inputClassName}
          type="radio"
          name={name}
          value={value_2}
          onChange={handleChange}
          onInput={inputFocus}
          checked={checked_2}
          datagroup={datagroup}
        />
        <label className="form-check-label">{value_2}</label>
      </div>
      <div className="form-check position-relative">
        <input
          className={"form-check-input radio-group getLabel " + inputClassName}
          type="radio"
          name={name}
          value={value_3}
          onChange={handleChange}
          onInput={inputFocus}
          checked={checked_3}
          datagroup={datagroup}
        />
        <label className="form-check-label">{value_3}</label>
        <div className="invalid-tooltip">
          Veuillez remplir ce champs obligatoire
        </div>
      </div>
    </>
  );
};

export default RadioMulti;
